<template>
    <footer class="pt-12 pb-20">
        <div
            class="-mb-8 flex flex-wrap content-center justify-center gap-x-2 gap-y-2 px-4 md:gap-x-4 md:gap-y-4"
        >
            <a
                href="https://github.com/glitchedmob"
                target="_blank"
                title="Github"
                rel="noopener"
                class="text-text hover:text-text-muted p-2 text-3xl no-underline transition-all duration-250 ease-in-out md:p-1 md:text-5xl"
            >
                <i class="icon-github" aria-hidden="true" />
            </a>
            <a
                href="https://dev.to/levi_zitting"
                target="_blank"
                title="Dev.to"
                rel="noopener"
                class="text-text hover:text-text-muted p-2 text-3xl no-underline transition-all duration-250 ease-in-out md:p-1 md:text-5xl"
            >
                <i class="icon-dev" aria-hidden="true" />
            </a>
            <a
                href="https://twitter.com/levi_zitting"
                target="_blank"
                title="Twitter"
                rel="noopener"
                class="text-text hover:text-text-muted p-2 text-3xl no-underline transition-all duration-250 ease-in-out md:p-1 md:text-5xl"
            >
                <i class="icon-twitter" aria-hidden="true" />
            </a>
            <a
                href="https://www.instagram.com/levi_zitting/"
                target="_blank"
                title="Instagram"
                rel="noopener"
                class="text-text hover:text-text-muted p-2 text-3xl no-underline transition-all duration-250 ease-in-out md:p-1 md:text-5xl"
            >
                <i class="icon-instagram" aria-hidden="true" />
            </a>
            <a
                href="https://techhub.social/@levizitting"
                target="_blank"
                title="Mastodon"
                rel="me"
                class="text-text hover:text-text-muted p-2 text-3xl no-underline transition-all duration-250 ease-in-out md:p-1 md:text-5xl"
            >
                <i class="icon-mastodon" aria-hidden="true" />
            </a>
            <a
                href="https://www.linkedin.com/in/levi-zitting/"
                target="_blank"
                title="Linkedin"
                rel="noopener"
                class="text-text hover:text-text-muted p-2 text-3xl no-underline transition-all duration-250 ease-in-out md:p-1 md:text-5xl"
            >
                <i class="icon-linkedin" aria-hidden="true" />
            </a>
            <a
                href="mailto:me@levizitting.com"
                title="Email"
                class="text-text hover:text-text-muted p-2 text-3xl no-underline transition-all duration-250 ease-in-out md:p-1 md:text-5xl"
            >
                <i class="icon-envelope" aria-hidden="true" />
            </a>
        </div>
    </footer>
</template>
